import $ from 'jquery'

function cityMatch() {
  let cityChName = $('.J-city').text()
  // let cityChName = '上海'
  let cityList = []
  let nodeList = $('.J-city-list .city-item')
  nodeList.map((index, item) => {
    cityList.push($(item).text())
  });
  let curCityIndex = cityList.indexOf(cityChName)
  if (curCityIndex !== -1) { 
    // 有匹配的城市，高亮
    $(nodeList[curCityIndex]).addClass('current-city')
  }

}



export default {
  init: function (config) {
    cityMatch(config)
  }
}


// WEBPACK FOOTER //
// ./modules/logo-input/js/city-change.js